import { jsx as _jsx } from "react/jsx-runtime";
import { TextField, InputAdornment } from "@mui/material";
import { SearchNormal } from "iconsax-react";
export const HSearchInput = ({ value, onChange, startIcon = _jsx(SearchNormal, {}), }) => {
    return (_jsx(TextField, { placeholder: "Search...", fullWidth: true, value: value, onChange: onChange, slotProps: {
            input: {
                startAdornment: startIcon ? (_jsx(InputAdornment, { position: "start", children: startIcon })) : null,
                sx: {
                    backgroundColor: "#919EAB14",
                    borderRadius: "12px",
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                },
            },
        } }));
};
